<template>
  <div>
    <div class="row" style="display: flex; align-items: end;" v-if="!showOnlyDescription">
      <div class="col-xs-2">
        <InputText
          :label="$t('Qty')"
          v-model="value.qty"
          :rules="{required: true}"/>
      </div>
      <div :class="showOrigin ? 'col-xs-4' : 'col-xs-8'">
        <ProductPicker
          :label="$t('desc')"
          v-model="value.description"
          :product="value.product ? value.product : {}"
          :rules="{required: true}"
          @productSelected="productSelected"
          @productRemoved="productRemoved"
        />
      </div>
      <div class="col-xs-3">
        <WeightSelect
          :label="$t('Unit weight')"
          v-model="value.unitWeight"
          :rules="{required: true}"/>
      </div>
      <div class="col-xs-3">
        <CurrencySelect
          :label="$t('Unit value')"
          v-model="value.unitValue"
          :rules="{required: false && showCustoms && !isCustomsInvoiceUploaded}"/><!-- false - temporary disable rules but preserve for later -->
      </div>
      <div class="col-xs-2" v-if="showOrigin">
        <InputText
          :label="$t('HS code')"
          v-model="value.hsCode"
          :rules="{required: false && showCustoms && !isCustomsInvoiceUploaded}"/><!-- false - temporary disable rules but preserve for later -->
      </div>
      <div :class="deletable ? 'col-xs-2' : 'col-xs-2'" v-if="showOrigin">
        <CountrySelect
          :tabindex="2"
          :isShortened="true"
          :label="$t('Origin')"
          v-model="value.origin"
          :no-continent="true"
          :rules="{required: false && showCustoms && !isCustomsInvoiceUploaded}"/><!-- false - temporary disable rules but preserve for later -->
      </div>
      <div v-if="deletable" class="col-xs-1 p-t-10">
        <Btn
          @click.native="deleteRow"
          class="gray"
          position="icon-pos-center"
          :icon="{
            name: 'deleteForever',
            size: '18',
          }"
        />
      </div>
    </div>
    <div class="row" style="display: flex; align-items: end;" v-if="showOnlyDescription">
      <div :class="deletable ? 'col-xs-11' : 'col-xs-12'">
        <InputText
          :label="$t('desc')"
          v-model="value.description"
          :rules="{required: true}"/>
      </div>
      <div v-if="deletable" class="col-xs-1 p-t-10">
        <Btn
          @click.native="deleteRow"
          class="gray"
          position="icon-pos-center"
          :icon="{
            name: 'airplane',
            size: '18',
            color: '#000',
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import InputText from '@/components/elements/inputs/text.vue';
import CurrencySelect from '@/components/elements/inputs/currencySelect.vue';
import CountrySelect from '@/components/elements/inputs/countrySelect.vue';
import WeightSelect from '@/components/elements/inputs/weightSelect.vue';
import Btn from '@/components/elements/buttons';
import ProductPicker from "@/components/global/productPicker/productPicker.vue";

export default {
  name: 'ContentRow',
  components: {
    ProductPicker,
    Btn,
    InputText,
    CurrencySelect,
    CountrySelect,
    WeightSelect
  },
  props: {
    isCustomsInvoiceUploaded: {
      type: Boolean,
      default: false,
    },
    deletable: {
      type: Boolean,
      default: false,
    },
    showOrigin: {
      type: Boolean,
      default: false,
    },
    showCustoms: {
      type: Boolean,
      default: false,
    },
    showOnlyDescription: {
      type: Boolean,
      default: false,
    },
    indexInData: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      default: () => {
        return {
          qty: 0,
          description: '',
          unitValue: {
            value: 0,
            unit: 'eur',
          },
          unitWeight: {
            unit: 'kg',
            value: '',
          },
          hsCode: '',
          origin: '',
        }
      },
    },
  },
  watch: {
    'value.qty': {
      handler(newVal){
          const qty = newVal;
          const productId = this.value.productId ? this.value.productId : null;
          this.$emit('quantityChange', {qty, productId})
      },
      deep: true
    }
  },
  methods: {
    productSelected(val) {
      const finalObject = {
        description: val.name,
        qty: 1,
        productId: val.id,
        productImage: val.image,
        sku: val.sku,
        hsCode: val.hs_code ? val.hs_code : this.value.hs_code,
        origin: val.origin_country_id ? val.origin_country_id : this.value.origin,
        unitValue: {
          unit : val.sales_price_currency ? val.sales_price_currency : 'dkk',
          value: val.sales_price ? val.sales_price : 0,
        },
        unitWeight: {
          unit: val.weight_unit ? val.weight_unit : 'kg',
          value: val.weight ? val.weight : 0
        },
        product: val
      }

      //Should not be executed on copy or draft shipment initially, only when user change packaging value
      this.selected = finalObject;
      this.$emit('input', finalObject);
      this.$emit('setProductDetails', val)
    },
    productRemoved($event) {
      this.$emit('input', $event)
      this.$emit('removeProduct', this.value.productId)
    },
    deleteRow() {
      if (this.value.productId) {
        this.selected = {}
        this.$emit('removeProduct', this.value.productId)
      }
      this.$emit('deleteRow', this.indexInData);
    },
  },
}
</script>
